import React from 'react'
import './index.scss'
import Tag from '../Tag'
function ProductItem(props: any) {
    const { product, handleClickItem } = props;
    const { favoritedCount, numberViews, origin, merchantName, labelView } = product;
    const {
        id,
        images,
        brand,
        nameCN,
        name,
        priceTag,
        priceTagCN,
        colors,
        badgeList
    } = product?.product || {};
    const numberView = numberViews?.[0] || {};

    function getLikeText() {
        return numberView.view === 'SALE_VIEW' && numberView.value ? `已卖${numberView.value}件`:
            favoritedCount ? `${favoritedCount}人收藏` : '';
    }
    return (
        <div className="m-product-item" onClick={() => handleClickItem(id)}>
            <div className="img-wrap">
                <img src={images?.[0]?.full?.url} />
            </div>
            <div className="detail">
                <div className="name">
                    {
                        badgeList?.[0] ?
                            <Tag className='rank-tag' backgroundColor='#fcf3f3' fontColor='#C7363A'>
                                <img src={require('../../assets/images/prod_rank_tag.png')} />
                                <div className='rank-tag-content'>{badgeList?.[0]?.text}</div>
                            </Tag> : null
                    }
                    {brand ? `${brand} | ` : ''}
                    {nameCN || name}
                </div>
                <div className='price-wrap'>
                    {priceTagCN ? <div className='main-price'>{priceTagCN}</div> : null}
                    {priceTag ? <div className='sub-price'>{priceTag}</div> : null}
                </div>
                {labelView?.shortLabels?.length ? <div className='promo-wrap'>
                    {labelView.shortLabels?.map(label => {
                        return (
                            <Tag
                                backgroundColor={`#${label?.labels?.[0]?.backgroundColor}`}
                                borderColor={`#${label?.labels?.[0]?.border?.color}`}
                            >
                                {label?.labels?.map(item => {
                                    return <span style={{color: `#${item.color}`}}>{item.text}</span>
                                })}
                            </Tag>
                        )
                    })}
                </div> : null}
                <div className='origin-wrap'>
                    <div className='origin'>
                        <span className='origin-text'>{origin}</span>
                        <span className='merchant-name'>{merchantName}</span>
                    </div>
                    {numberView.view === 'SALE_VIEW' && numberView.value ? <div className='sale-num'>已卖{numberView.value}件</div> : null}
                </div>
            </div>
            {colors?.length ? (
                <div className="color-num">
                    <Tag backgroundColor="#F2F2F2" fontColor="#666666">
                        {colors?.length}色可选
                    </Tag>
                </div>
            ) : null}
        </div>
    )
}

export default ProductItem
